var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1523 8.8186H11.3398C10.964 8.8186 10.6523 8.50694 10.6523 8.1311C10.6523 7.75527 10.964 7.4436 11.3398 7.4436H16.1523C16.5282 7.4436 16.8398 7.75527 16.8398 8.1311C16.8398 8.50694 16.5373 8.8186 16.1523 8.8186Z",
    fill: "#F7A703"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52896 9.51507C6.35479 9.51507 6.18062 9.4509 6.04312 9.3134L5.35563 8.62588C5.08979 8.36004 5.08979 7.92004 5.35563 7.65421C5.62146 7.38838 6.06146 7.38838 6.32729 7.65421L6.52896 7.85588L8.10563 6.27921C8.37146 6.01338 8.81146 6.01338 9.07729 6.27921C9.34315 6.54504 9.34315 6.98504 9.07729 7.25088L7.01479 9.3134C6.88646 9.44174 6.71229 9.51507 6.52896 9.51507Z",
    fill: "#F7A703"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1523 15.2349H11.3398C10.964 15.2349 10.6523 14.9232 10.6523 14.5474C10.6523 14.1715 10.964 13.8599 11.3398 13.8599H16.1523C16.5282 13.8599 16.8398 14.1715 16.8398 14.5474C16.8398 14.9232 16.5373 15.2349 16.1523 15.2349Z",
    fill: "#F7A703"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52896 15.9318C6.35479 15.9318 6.18062 15.8676 6.04312 15.7301L5.35563 15.0426C5.08979 14.7768 5.08979 14.3368 5.35563 14.071C5.62146 13.8051 6.06146 13.8051 6.32729 14.071L6.52896 14.2726L8.10563 12.696C8.37146 12.4301 8.81146 12.4301 9.07729 12.696C9.34315 12.9618 9.34315 13.4018 9.07729 13.6676L7.01479 15.7301C6.88646 15.8585 6.71229 15.9318 6.52896 15.9318Z",
    fill: "#F7A703"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7526 20.8543H8.2526C3.2751 20.8543 1.14844 18.7277 1.14844 13.7502V8.25016C1.14844 3.27266 3.2751 1.146 8.2526 1.146H13.7526C18.7301 1.146 20.8568 3.27266 20.8568 8.25016V13.7502C20.8568 18.7277 18.7301 20.8543 13.7526 20.8543ZM8.2526 2.521C4.02677 2.521 2.52344 4.02433 2.52344 8.25016V13.7502C2.52344 17.976 4.02677 19.4793 8.2526 19.4793H13.7526C17.9784 19.4793 19.4818 17.976 19.4818 13.7502V8.25016C19.4818 4.02433 17.9784 2.521 13.7526 2.521H8.2526Z",
    fill: "#F7A703"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/Survey.6368ff6fa219b3008e63eb7412b68542.svg";
export { ForwardRef as ReactComponent };